import ApiService from "@/service/apiService";
import routeur from "@/router/router";
let user = null;
let loadingPromise = null;

export default {
  async fetchUser() {
    if (user !== null) return user;
    if (loadingPromise !== null) return loadingPromise;

    loadingPromise = ApiService.auth
      .me()
      .then((res) => {
        user = res.data;
        return user;
      })
      .catch((err) => {
        user = null;
        routeur.push({ name: "Login" });
      })
      .finally(() => {
        loadingPromise = null;
      });

    return loadingPromise;
  },

  async getUser() {
    return user !== null ? user : await this.fetchUser();
  },

  isAuthenticated() {
    return user !== null;
  },

  clearUser() {
    user = null;
    loadingPromise = null;
  },

  logout() {
    user = null;
    loadingPromise = null;
    return ApiService.auth.logout().then(() => {
      routeur.push({ name: "Login" });
    });
  },
};
